import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DetraccionSelect } from 'sharedComponents/select'

const CodigoDetraccionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DETRACCION' htmlFor='select-detraccion' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='codigoDetraccion'>
          {({ field }) => (
            <DetraccionSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-detraccion'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoDetraccionFormGroup)
